import { Component } from '@angular/core';
import { PageTemplateWindowComponent } from './page-template-window.component';
import { SectionTemplateModel } from '../kymw2400/vo/section-template.model';
import { CalcUtil } from '../../../commons/kymw00/calc-util.service';

@Component({
  selector: 'app-section',
  template: '',
})
export class SectionTemplateComponent {
  // 描画するセクション情報
  public drawSectionSizeW = 0;
  public drawSectionSizeH = 0;
  public drawSectionPositionX = 0;
  public drawSectionPositionY = 0;

  public sectionId = String('');
  /** X位置(mm) */
  public positionX: number = null;
  /** Y位置(mm) */
  public positionY: number = null;
  /** 幅(mm) */
  public sizeW: number = null;
  /** 高さ(mm) */
  public sizeH: number = null;
  public divX = Number(1);							// 横のグリッド数
  public divY = Number(1);							// 縦のグリッド数

  public page: PageTemplateWindowComponent = null;

  private _selected: boolean = null;

  public readonly SAVE_AREA_TYPE: number = Number(1);
  public readonly NORAML_AREA_TYPE: number = Number(0);

  public sectionID: string = null;
  public sectionName: string = null;

  public side = Number(0); // 0:左　1:右

  public typeSetID: string = null;

  public areaType: number = null;

  public attachment = Boolean(true); // 吸着判定

  /**
   * コンストラクタ
   */
  constructor(
  ) { }

  /**
   * セクションデータ設定
   *
   * @param sectionData:
   * @param pageWidth:
   * @param pageHeight:
   */
  public setData(sectionData: any): void {
    // データ初期化処理
    this.clear();

    // ページ情報取得
    this.sectionId = String(sectionData.SectionTemplateID);
    this.sectionName = String(sectionData.SectionTemplateName);
    this.positionX = parseFloat(sectionData.PositionX);
    this.positionY = parseFloat(sectionData.PositionY);
    this.sizeW = parseFloat(sectionData.Width);
    this.sizeH = parseFloat(sectionData.Height);
    this.divX = Number(sectionData.DivW);
    this.divY = Number(sectionData.DivH);

  }

  public set selected(selectedFlag: boolean) {
    this._selected = selectedFlag;
  }

  public get selected(): boolean {
    return this._selected;
  }

  /**
   * セクション情報をクリアする
   */
  public clear(): void {
    this.sectionId = '';
    this.sizeW = 0;
    this.sizeH = 0;
    this.divX = 1;
    this.divY = 1;
  }

  /**
   * SectionTemplateVO作成
   *
   * @returns {SectionTemplateModel}
   * @memberof SectionTemplateComponent
   */
  public createSectionTemplateVO(): SectionTemplateModel {
    const vo: SectionTemplateModel = new SectionTemplateModel();
    vo.sectionTemplateID = this.sectionId;
    vo.sectionTemplateName = this.sectionName;
    // 項番2231 START 障害管理NO.U01748対応
    // vo.positionX = this.page.width * this.positionX;
    // vo.positionY = this.page.height * this.positionY;
    // vo.width = this.page.width * this.sizeW;
    // vo.height = this.page.height * this.sizeH;
    vo.positionX = String(this.page.width * this.positionX);
    vo.positionY = String(this.page.height * this.positionY);
    vo.width = String(this.page.width * this.sizeW);
    vo.height = String(this.page.height * this.sizeH);
    // 項番2231 END 障害管理NO.U01748対応
    vo.divH = this.divY;
    vo.divW = this.divX;

    return vo;
  }

  /**
   * セクションの上下左右の座標を取得する
   * @param pageDivW セクションが配置されているページの分割数(横)
   * @param pageDivH セクションが配置されているページの分割数(縦)
   */
  public getPosition(pageDivW: number, pageDivH: number): any {
    return this.calcPosition(
      this.positionX, this.positionY,
      this.sizeW, this.sizeH,
      pageDivW, pageDivH);
  }

  /**
   * 位置・サイズの割合の値からページにおけるセクションの座標値を計算する
   * @param percentPositionX X位置(mm)
   * @param percentPositionY Y位置(mm)
   * @param percentWidth 幅(mm)
   * @param percentHeight 高さ(mm)
   * @param pageDivW セクションが配置されているページの分割数(横)
   * @param pageDivH セクションが配置されているページの分割数(縦)
   */
  private calcPosition(
    percentPositionX: number, percentPositionY: number,
    percentWidth: number, percentHeight: number,
    pageDivW: number, pageDivH: number): any {

    let top: number = percentPositionY * pageDivH;
    let left: number = percentPositionX * pageDivW;
    let bottom: number = (percentPositionY + percentHeight) * pageDivH;
    let right: number = (percentPositionX + percentWidth) * pageDivW;

    // 小数点以下第2位で四捨五入(最小が1/2サイズ＝最小の値は0.5なので第1位までの小数に丸める)
    top = Number(CalcUtil.round(String(top), 1));
    left = Number(CalcUtil.round(String(left), 1));
    bottom = Number(CalcUtil.round(String(bottom), 1));
    right = Number(CalcUtil.round(String(right), 1));

    return { top: top, left: left, bottom: bottom, right: right };
  }
}
